import { render, staticRenderFns } from "./SearchNpa.vue?vue&type=template&id=2a81c336&scoped=true"
import script from "./SearchNpa.vue?vue&type=script&lang=js"
export * from "./SearchNpa.vue?vue&type=script&lang=js"
import style0 from "./SearchNpa.vue?vue&type=style&index=0&id=2a81c336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81c336",
  null
  
)

export default component.exports